// extracted by mini-css-extract-plugin
export default {"action":"ContinueBlock_action__8VgXl"};